import React, { useState } from 'react';
import axios from 'axios';
import { SuperDashboard } from './pages/super/SuperDashboard';

const API = process.env.REACT_APP_API_URL ?? 'https://echoes-of-the-word-production.up.railway.app/api/v1';

const T = {
  burgundy: '#6B1E2E',
  parchment: '#F5EDD8',
  parchmentLight: '#FBF6EC',
  ink: '#2C2015',
  inkLight: '#8C7A65',
  border: '#D4C5B0',
  white: '#FFFFFF',
  error: '#B91C1C',
};

function LoginPage({ onLogin }: { onLogin: () => void }) {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      const { accessToken, refreshToken } = res.data.data ?? res.data;
      localStorage.setItem('access_token',  accessToken);
      localStorage.setItem('refresh_token', refreshToken);
      onLogin();
    } catch (err: any) {
      setError(err?.response?.data?.message ?? 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: T.parchmentLight,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif',
      padding: 24,
    }}>
      <div style={{
        background: T.white,
        border: `0.5px solid ${T.border}`,
        borderRadius: 16,
        padding: '48px 40px',
        width: '100%',
        maxWidth: 400,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>✝</div>
          <h1 style={{
            fontFamily: 'Georgia, serif',
            fontSize: 22,
            color: T.ink,
            fontWeight: 600,
            marginBottom: 6,
          }}>
            Echoes of the Word
          </h1>
          <p style={{ fontSize: 13, color: T.inkLight }}>Super Admin Dashboard</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: T.inkLight, letterSpacing: '0.5px', marginBottom: 6, textTransform: 'uppercase' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="admin@example.com"
              style={{
                width: '100%',
                padding: '10px 14px',
                border: `0.5px solid ${T.border}`,
                borderRadius: 8,
                fontSize: 14,
                color: T.ink,
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: T.inkLight, letterSpacing: '0.5px', marginBottom: 6, textTransform: 'uppercase' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              style={{
                width: '100%',
                padding: '10px 14px',
                border: `0.5px solid ${T.border}`,
                borderRadius: 8,
                fontSize: 14,
                color: T.ink,
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>

          {error && (
            <div style={{
              background: '#FEF2F2',
              border: '0.5px solid #FECACA',
              borderRadius: 8,
              padding: '10px 14px',
              fontSize: 13,
              color: T.error,
              marginBottom: 20,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: loading ? T.inkLight : T.burgundy,
              color: T.white,
              border: 'none',
              borderRadius: 8,
              padding: '12px',
              fontSize: 15,
              fontWeight: 600,
              fontFamily: 'system-ui',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: T.inkLight }}>
          <a href="https://justifiedproductionz.co.za" style={{ color: T.inkLight }}>
            ← Back to justifiedproductionz.co.za
          </a>
        </p>
      </div>
    </div>
  );
}

export default function App() {
  const [loggedIn, setLoggedIn] = useState(() => !!localStorage.getItem('access_token'));

  if (!loggedIn) {
    return <LoginPage onLogin={() => setLoggedIn(true)} />;
  }

  return <SuperDashboard onLogout={() => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setLoggedIn(false);
  }} />;
}
